import FlakeId from "flake-idgen";
import intFormat from "biguint-format";

const flakeIdGen = new FlakeId({ epoch: 1300000000000 });

export default function getUniqueId() {
  return intFormat(flakeIdGen.next(), "dec");
}
